<template>
    <b-overlay :show="loading">

        <!-- Show featured podcast. -->
        <div v-if="haveFeaturedPodcast" class="div-section-body" style="padding: 0 2px 0 3px;">
            <div class="mt-2">
                <b-row>
                    <b-col>
                        <div class="class-title ml-2">Featured Podcast: {{ podcasts[featuredPodcastIx].title }}</div>
                        <b-row class="pb-2" @click.stop.prevent="activateRow(podcasts[featuredPodcastIx].hash, featuredPodcastIx)">
                            <b-col cols="4" lg="2" class="text-center ml-3 mt-2">
                                <b-img fluid v-bind:src="podcasts[featuredPodcastIx].photo" />
                            </b-col>
                            <b-col cols="6" lg="8" class="mt-3">

                                <div class="class-details">
                                    Guest: {{ podcasts[featuredPodcastIx].speakerName }}
                                    <br><b-icon icon="clock"></b-icon>&nbsp;{{ podcasts[featuredPodcastIx].durationSec | prettySeconds }}
                                </div>
                                <b-link @click.stop.prevent="play(featuredPodcastIx)">
                                    <b-icon v-if="!isRowPlaying(featuredPodcastIx)" icon="play-fill" font-scale="2.5"></b-icon>
                                    <b-icon v-if="isRowPlaying(featuredPodcastIx)" icon="pause-fill" font-scale="2.5"></b-icon>
                                </b-link>

                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6" offset-md="3">
                                <div class="mt-2 ml-2">
                                    <div class="txt-class-blurb" v-html="podcasts[featuredPodcastIx].featuredBlurb"></div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </div>
        </div>

        <div class="div-section-header mb-2">
            <b-row>
                <b-col cols="12">
                    <span class="txt-section-subtitle">More Podcast Episodes</span>
                </b-col>
            </b-row>
        </div>

        <!-- recent episodes -->
        <div class="div-section-body">
            <div v-for="(row, ix) in podcasts" v-bind:key="row.id" class="mt-2 mb-2 pointer">
                <template v-if="ix != featuredPodcastIx">
                    <b-row @click.stop.prevent="activateRow(row.hash, ix)" class="pb-2">
                        <b-col cols="2" lg="1" :class="['text-center', { active: isActiveRow(row.hash) }]">
                            <b-link @click.stop.prevent="play(ix)">
                                <b-icon v-if="!isRowPlaying(ix)" icon="play-fill" font-scale="2.5"></b-icon>
                                <b-icon v-if="isRowPlaying(ix)" icon="pause-fill" font-scale="2.5"></b-icon>
                            </b-link>
                        </b-col>
                        <b-col cols="10" lg="11" style="margin-left: -10px;" :class="{ active: isActiveRow(row.hash) }">
                            <div class="class-title">{{ row.title }}</div>
                            <div class="class-details">
                                Guest: {{ row.speakerName }}
                                <br><b-icon icon="clock"></b-icon>&nbsp;{{ row.durationSec | prettySeconds }}
                            </div>
                        </b-col>
                    </b-row>
                    <div v-if="ix < numPodcasts-1" class="w-100" style="margin-left:-5px; border-bottom: 1px solid #CCC;"></div>
                </template>
            </div>
        </div>
    </b-overlay>
</template>

<script>
'use strict'
/* eslint-disable */

import service from "@/service/service"
import utils from "@/utils/utils"
import EventBus from '@/plugins/eventbus'

export default {
  name: "LobbyPodcasts",
  data() {
    return {
      debug: false,
      error: false,
      errorMsg: null,
      busy: false,
      success: false,
      loading: true,
      classHash: null,
      studentHash: null,
      podcasts: [],
      podcastHash: null,
      podcastShowHash: null,
      featuredPodcastIx: -1,
      featuredPodcastClicks: 0,
      curPodcastIx: -1,  // less than zero to init
      playing: false
    }
  },
  props: {
    ch: {  // classObj hash
      type: String,
      default: null
    },
    sh: {  // student hash
      type: String,
      default: null
    },
    parr: {     // array of podcast objects
        type: Array,
        default: []
    }
  },
  computed: {
    haveFeaturedPodcast() {
      return (this.featuredPodcastIx >= 0)
    },
    numPodcasts() {
      return this.podcasts.length
    }
  },
  methods: {
    isRowPlaying(ix) {
      let aout = (ix == this.curPodcastIx) && this.playing
      return aout
    },
    isActiveRow(hash) {
      return (this.podcastHash == hash)
    },
    activateRow(hash, ix) {
      this.podcastHash = hash
      this.curpodcastIx = ix
    },
    play(ix) {   // this.podcasts[ix]
        if (this.debug) console.log(`playing ix: ${ix}  cur: ${this.curPodcastIx}`)

        if (this.curPodcastIx == ix) {
            // toggle play on current ix
            if (!this.playing) {
              // play
              if (ix == this.featuredPodcastIx) ++this.featuredPodcastClicks
              EventBus.$emit('podcast-play',null)
            } else {
              // pause
              this.pause()
            }
        }
        else {  // playing new podcast
          if (this.curPodcastIx >= 0 && this.playing) {
            this.pause()  // pause existing podcast
          }
          this.curPodcastIx = ix
          this.podcastHash = this.podcasts[ix].hash
          if (ix == this.featuredPodcastIx) ++this.featuredPodcastClicks

          // log play of new podcast
          let data = {
            title: this.podcasts[ix].title,
            mp3: this.podcasts[ix].mp3
          }
          EventBus.$emit('podcast-play',data)
        }
    },
    pause() {
      EventBus.$emit('podcast-pause', null)
    },
    logPlay() {

      // only first featured podcast listen(click) is logged to VPAdLog table.
      let logFeaturedPodcast = (this.curPodcastIx == this.featuredPodcastIx) && (this.featuredPodcastClicks == 1)

      // when logFeaturedPodcast is true will log both the podcast isten and a
      service
        .podcastView(this.podcastHash, this.studentHash, logFeaturedPodcast, 'webinar')
        .then(
          (res => {
            if (this.debug) console.log(res)
            if (res.status) {
              // not much to do...?
            }
            else {
              this.error = true
              this.errorMsg = 'Error logging podcast play.'
            }
          }).bind(this)
        )
        .finally(e => {
          if (this.debug) console.log(`finally logPlay...`)
        })
        .catch(e => {
          this.error = true
          this.errorMsg = 'System error. Logging API failure.'
          console.log(e)
        })
    }
  },
  created() {
    if (this.debug) console.log(`Created LobbyLive`)

    this.podcasts = this.parr
    this.classHash = this.ch
    this.studentHash = this.sh

    this.curPodcastIx = -1
    this.featuredPodcastIx = -1
    this.featuredPodcastClicks = 0

    EventBus.$on( 'podcast-play-event',  (function () {
      if (this.debug) console.log(`podcast-play-event`)
      this.playing = true
      this.logPlay()
    }).bind(this))

    EventBus.$on( 'podcast-pause-event', (function () {
      if (this.debug) console.log(`podcast-pause-event`)
      this.playing = false
    }).bind(this))

    this.loading = true

    // console.log(`podcastHash ${this.podcastHash} plen: ${this.podcasts.length}`)
    for(let ix=0; ix < this.podcasts.length; ix++) {
        // console.log(`testing podcastHash ${this.podcastHash} phash: ${this.podcasts[ix].hash}`)
        if (this.podcasts[ix].lobbyTypeId == 1) {
            // console.log(`this.featuredPodcastIx ${this.featuredPodcastIx}`)
            this.featuredPodcastIx = ix // set featured ix
            break
        }
    }
    this.loading = false
    if (!this.playing && this.featuredPodcastIx >= 0) {
        if (this.debug) console.log(`Autoplay: ${this.featuredPodcastIx}`)
        this.play(this.featuredPodcastIx)
    }
    else {
        if (this.debug) console.log(`NO Autoplay: ${this.featuredPodcastIx}`)
    }
    if (this.debug) console.log(`finally LobbyLive...`);
  },
  mounted() {
    if (this.debug) console.log(`Mounted LobbyPodcasts`)
    // this.busy = false
    // this.success = false
  },
  beforeDestroy() {
    if (this.debug) console.log(`BeforeDestroy LobbyPodcasts`)
    this.featuredPodcastIx = -1
    this.featuredPodcastClicks = 0
    this.curPodcastIx = -1
    EventBus.$off( 'podcast-play-event')
    EventBus.$off( 'podcast-pause-event')
    // this.podcastShow = {status: false}
    // this.podcasts = []
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LobbyPodcasts.vue